package com.macrofocus.eflux.ui

import com.macrofocus.eflux.time.TimeTracker
import com.macrofocus.eflux.toDateTime
import com.macrofocus.eflux.toJsDate
import com.macrofocus.eflux.toRawString
import mui.material.Size
import mui.material.TextField
import mui.material.TextFieldProps
import mui.system.sx
import muix.pickers.AdapterDateFns
import muix.pickers.DateTimePicker
import muix.pickers.LocalizationProvider
import org.mkui.react.useProperty
import react.FC
import react.PropsWithChildren
import react.create
import web.cssom.px
import kotlin.js.Date

external interface DateChooserProps : PropsWithChildren {
    var timeTracker: TimeTracker
}

val DateChooser = FC<DateChooserProps> { props ->
    val DEBUG = false

//    val (t, _) = useTranslation()

    val (displayDateTime, _) = useProperty(props.timeTracker.displayDateTime)
    val (displayDateTimeRaw, _) = useProperty(props.timeTracker.displayDateTimeRaw)
    val (masterDateTime, _) = useProperty(props.timeTracker.masterDateTime)
    val (earliestDateTime, _) = useProperty(props.timeTracker.earliestDateTime)
    val (latestDateTime, _) = useProperty(props.timeTracker.latestDateTime)

    val dateString = displayDateTime.toRawString()
    if(DEBUG) {
        println("DateTimePicker date is $dateString (display= ${displayDateTimeRaw}, master=${masterDateTime.toRawString()})")
    }

    val earliest = earliestDateTime.toJsDate()
    val latest = latestDateTime.toJsDate()
    val display = displayDateTime.toJsDate()

    LocalizationProvider {
        dateAdapter = AdapterDateFns
        @Suppress("UPPER_BOUND_VIOLATED")
        DateTimePicker {
            asDynamic().arialLabel = dateString
            asDynamic().style = "max-width: 200px;"
//            css {
//                color = Color.currentcolor
//            }

            asDynamic().variant = "inline"
            asDynamic().renderInput = { textFieldProps: TextFieldProps ->
                TextField.create() {
                    sx {
                        maxWidth = 215.px
                    }

                    for (i in textFieldProps.asMap()) {
                        set(i.key, i.value)
                    }
                    size = Size.small
                    //                                sx = unsafeJso {
                    //                                    marginRight = (-30).px
                    //                                }
                }
                //                            buildElement {
                //                                TextField {
                //                                    for (i in textFieldProps.asMap()) {
                //                                        attrs.set(i.key, i.value)
                //                                    }
                //                                    attrs.size = Size.small
                //
                ////                                            attrsFrom(textFieldProps)
                ////                                            attrs.helperText = "".asTextNode()
                //                                }
                //                            }
            }
            asDynamic().inputFormat = "dd.MM.yyyy HH:mm"
//            val date = getDisplayDate
//                    println("DateTimePicker date is ${date.toRawString()}")
            asDynamic().value = display
            asDynamic().showTodayButton = false
            asDynamic().ampm = false
            asDynamic().minutesStep = 5
            asDynamic().minDateTime = earliest
            asDynamic().maxDateTime = latest
//                    asDynamic().minDateTime = getMinDateTime
//                    asDynamic().maxDateTime = getMaxDateTime
            asDynamic().onChange = { date: Date, selectionState: dynamic ->
                try {
                    date?.let { props.timeTracker.dateInputted(it.toDateTime(), true) }
                } catch (e: Throwable) {
                    println(e.message)
                    println(e.cause)
                }
//                        date?.let { setDateTime(it.toDateTime()) }
            }
        }
    }

//            LocalizationProvider {
////                    val history = useHistory()
////                    val lang = language(history)
////                    val lang = props.lang
//
//                asDynamic().dateAdapter = { options: dynamic -> KlockDateTimeUtils(options) }
////                        when(dateLibrary) {
////                            DateLibrary.DateTime -> localDateTimeAdapter()
////                            DateLibrary.Klock -> klockDateTimeAdapter()
////                            else -> {
////                                // FNS
////                                val locale = when (lang) {
////                                    Languages.GERMAN -> de
////                                    Languages.FRENCH -> frCH
////                                    Languages.ITALIAN -> frCH
////                                    else -> enUS
////                                }
////                                dateFnsAdapter()
////                                this.locale = locale
////                                locale(locale)
////                                dateFormats(defaultDateFnsFormats)
////                            }
////                        }
//
//
//                DateTimePicker {
//                    asDynamic().variant = "inline"
//                    asDynamic().renderInput = { textFieldProps: TextFieldProps ->
//                        TextField.create() {
//                            for (i in textFieldProps.asMap()) {
//                                set(i.key, i.value)
//                            }
//                            size = Size.small
//                            //                                sx = unsafeJso {
//                            //                                    marginRight = (-30).px
//                            //                                }
//                        }
//                        //                            buildElement {
//                        //                                TextField {
//                        //                                    for (i in textFieldProps.asMap()) {
//                        //                                        attrs.set(i.key, i.value)
//                        //                                    }
//                        //                                    attrs.size = Size.small
//                        //
//                        ////                                            attrsFrom(textFieldProps)
//                        ////                                            attrs.helperText = "".asTextNode()
//                        //                                }
//                        //                            }
//                    }
//                    asDynamic().inputFormat = "dd.MM.yyyy HH:mm"
//                    val date = getDateTime
//                    println("DateTimePicker date is ${date.toRawString()}")
//                    asDynamic().value = date
//                    asDynamic().showTodayButton = false
//                    asDynamic().ampm = true
//                    asDynamic().minutesStep = 5
//                    asDynamic().minDateTime = getMinDateTime
//                    asDynamic().maxDateTime = getMaxDateTime
//                    asDynamic().onChange = { date: dynamic ->
//                        if (date is Date) {
//                            val d = date
//                            println("Setting date to " + d.toDateTime())
//                            setDateTime(d.toDateTime())
//                        } else if (date is DateTime) {
//                            val d = date
//                            println("Setting date to " + d)
//                            setDateTime(d)
//                        } else {
//                            println("Unknown date type $date")
//                        }
//                    }
//                }
//            }
}